import DetailsPage from './DatailsPage'

export default DetailsPage